export default __webpack_public_path__ + "static/media/mouse.193edbd2.png";